import { Directive, Input } from '@angular/core';
import {
  NG_VALIDATORS,
  FormControl,
  Validator,
  AbstractControl,
  ValidationErrors
} from '@angular/forms';

import * as CardValidator from 'card-validator';

@Directive({
  selector: '[validCardCvc][ngModel]',
  providers: [
    {provide: NG_VALIDATORS, useExisting: JbCardCvcValidator, multi: true}
  ]
})
export class JbCardCvcValidator implements Validator {
  public validate(c: FormControl): ValidationErrors | any {
    const validation = CardValidator.cvv(c.value);

    return validation.isPotentiallyValid ? null : {
      validCardCvc: {
        valid: false
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/form/validators/cardCvc.validator.ts